import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { NSCustomizedReportingConstants } from '@ruby/configs/customized-reporting.constants';
import { ICRHistoryExecutions } from '@ruby/modules/customized-reporting/models/report.interface';

@Component({
  selector: 'ng-report-details-execution',
  templateUrl: './report-details-execution.component.html',
  styleUrls: ['./report-details-execution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportDetailsExecutionComponent implements OnChanges, AfterViewInit {
  @Input() historyExecutions!: Array<ICRHistoryExecutions>;
  @ViewChild(MatSort) sort!: MatSort;
  dataSource!: MatTableDataSource<ICRHistoryExecutions>;
  columns = NSCustomizedReportingConstants.reportManagementHistoryExecutions;

  constructor() { }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.historyExecutions && changes.historyExecutions.currentValue) {
      this.dataSource = new MatTableDataSource(changes.historyExecutions.currentValue);
    }
  }
}
